import { BaseService } from './base.service';

export class ItemQtyHistoriesService extends BaseService {
  static get resourceEndpoint() {
    return 'item-qty-histories';
  }
}
